export const getCountries = async () => {
  const res = await (await fetch(window.location.origin + '/data/country-code.json')).json()
  return res
}
